import { svg } from 'lit-element';

export const back = svg`<svg viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg"><path d="M0 8l8-8 1.5 1.5L3 8l6.5 6.5L8 16 0 8z"/></svg>`;
